import { format as stringFormat } from 'tools/string'
import { POSTAL_CODE_FORMATS } from 'tools/validation'

export const isPostalCodeValid = (countryCode, string) => {
  const POSTAL_CODE_FORMAT = POSTAL_CODE_FORMATS[countryCode]
  if (POSTAL_CODE_FORMAT) {
    return POSTAL_CODE_FORMAT.test(string)
  } else {
    // No postal code format defined
    return false
  }
}

export const deliveryAddressToAddress = (d) => {
  return ({
    autoCompleteAddress: d.deliveryAddress,
    address: d.deliveryAddressOne,
    addressTwo: d.deliveryAddressTwo,
    city: d.deliveryAddressCity,
    state: d.deliveryAddressState,
    postal: d.deliveryAddressPostal,
    country: d.deliveryAddressCountry,
    latitude: d.latitude,
    longitude: d.longitude
  })
}

export const storeOrderToDeliveryAddress = (storeOrder) => ({
  deliveryAddress: storeOrder.deliveryAddressAutoComplete || storeOrder.deliveryAddress,
  deliveryAddressOne: storeOrder.deliveryAddressOne,
  deliveryAddressTwo: storeOrder.deliveryAddressTwo,
  deliveryAddressCity: storeOrder.deliveryAddressCity,
  deliveryAddressState: storeOrder.deliveryAddressState,
  deliveryAddressCountry: storeOrder.deliveryAddressCountry,
  deliveryAddressPostal: storeOrder.deliveryAddressPostal,
  latitude: storeOrder.customerLatitude,
  longitude: storeOrder.customerLongitude,
  addressTwoDetails: storeOrder.addressTwoDetails
})

export const toDeliveryAddress = (address) => ({
  selectedAddressId: address.id,
  deliveryAddress: address.autoCompleteAddress,
  deliveryAddressOne: address.address,
  deliveryAddressTwo: address.addressTwo,
  deliveryAddressCity: address.city,
  deliveryAddressState: address.state,
  deliveryAddressCountry: address.country,
  deliveryAddressPostal: address.postal,
  latitude: address.latitude,
  longitude: address.longitude,
  addressTwoDetails: address.addressTwoDetails
})

// Converts a given address object into a formatted string. The format follows
// the address format passed in from the backend through meta in the head.
export const toAddressString = (addressObj, format = '{{addressOne}}, {{country}}, {{postal}}') => {
  // const newObj = {...addressObj, addressOne: addressObj.address}

  // Replace {{key}} with newObj.key
  const result = stringFormat(format, (_, key) => addressObj[key] || '{{EMPTY}}')

  return result
    .replace(/ *{{EMPTY}},? */g, ' ') // Remove any blanks
    .trim()
    .replace(/,$/, '') // Remove ending colon if there is
}

// Temporary Fix: hardcoded which elements in the first line and the second line group
// until new addressFormat configuration received from the backend
export const getLocalizedAddressCard = ({ countryCode, address }) => {
  switch (countryCode) {
    case 'TW':
      return {
        firstLine: [address.postal, address.country, address.state, address.city],
        secondLine: [address.address, address.addressTwo]
      }
    default:
      return {
        firstLine: [address.address, address.addressTwo],
        secondLine: [address.city, address.state, address.country, address.postal]
      }
  }
}

const addressMap = {
  addressOne: 'address',
  addressTwo: 'addressTwo',
  city: 'addressCity',
  state: 'addressState',
  postal: 'addressPostal',
  country: 'addressCountry'
}

/* Sample addressFormat and requiredAddressFields received from back-end
{
  "_id" : ObjectId("564c1f37ff220d3e4c450bae"),
  "countryName" : "Singapore",
  "addressFormat" : "{{addressOne}}, {{addressTwo}}, {{country}}, {{postal}}",
  "requiredAddressFields" : "addressHeader, addressPostalHeader"
}
*/
export const getOrderedAddressFields = (addressFormat = '', addressRequiredFields = '') => {
  const orderedAddressFields = []

  // Use regex to capture the element inside the {{ }} and put it into an array
  const addressFields = []
  stringFormat(addressFormat, (_, field) => addressFields.push(field))

  const requiredFields = addressRequiredFields.replace(/Header/g, '').replace(/ /g, '').split(',')

  addressFields.map((field) => orderedAddressFields.push({ field, isRequired: !!requiredFields.includes(addressMap[field]) }))
  return orderedAddressFields
}
